(function () {
    'use strict';

    angular
        .module('app')
        .controller('tests', tests);

    tests.$inject = ['searchService', '$timeout', '$rootScope', '$localStorage', 'loginService', 'hubFactory']; 

    function tests(searchService, $timeout, $rootScope, $localStorage, loginService, hubFactory) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'tests';
        vm.stop = false;
        vm.running = false;
        vm.responses = [];
        var myHub = hubFactory("testHub", function () {
            console.log("Connected");
            myHub.invoke("hello", "this is my message");
        });
        vm.connect = function () {
            myHub.on('hello', function () {
                console.log("hello");

            });
            myHub.start({ testId: 1234 });
            
            
        }


        vm.disconnect = function () {

            myHub.stop();
        }

        vm.startTest = function (start) {
            vm.running = true;
            if (start) {
                vm.stop = false;
            }
            if (!vm.stop || start) {
                
                vm.criteria = [{
                    schemaID: 'SCHEMA_S_LONGNAME',
                    valueStr: 'a',
                    startDate: "sample string 3",
                    endDate: "sample string 4",
                    searchOp: 0
                }];

                var id = 0;

                searchService.searchCriteria = vm.criteria;

                searchService.getData(0, 500, 1000, "SCHEMA_S_LONGNAME", 0).promise.then(function (response) {
                    vm.responses.push({ id: id, text: 'Test completed with token: ' + loginService.refresh_token + " " + new Date() });
                    id = id + 1;
                    //simulate a disconnect
                    $rootScope.loginHub.stop();

                    $timeout(function () {
                        $rootScope.loginHub.start({ userId: $localStorage.userInfo.id, autoLogin: $localStorage.userInfo.autoLogin });
                    }, 3000);

                    $timeout(function () {
                        vm.startTest();
                    }, Math.floor((Math.random() * 30000) + 10000));
                    
                }, function (response) {
                    console.log(response);
                })
            }
            else {
                vm.running = false;
            }
            
        }


        vm.stopTest = function () {
            vm.stop = true;
            vm.running = false;
        }
    }

})();
